<template>
  <div
    ref="dataBoardC"
    class="data-board"
    :style="{
      border: isLayoutSet ? '1px dashed #d9d9d9' : '1px solid #d9d9d9',
    }"
  >
    <div class="databoard">
      <div class="databoard_header flex">
        <div class="title">
          <eui-icon icon="eicon-cgbb" color="#333" font-size="18px" />
          <div class="text">采购报表</div>
        </div>
        <el-popover
          ref="popover"
          class="popover"
          placement="bottom"
          :offset="-20"
          trigger="click"
        >
          <div>
            <el-date-picker
              v-model="queryData.date"
              :clearable="false"
              class="datepicker"
              type="monthrange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              :picker-options="pickerOptions"
              @change="dateSet"
            ></el-date-picker>
          </div>
          <div slot="reference" class="date flex">
            <img src="@/assets/img/workbench/date.png" height="16px" alt="" />
            <p>
              {{ getFormatDate() }}
              <i class="el-icon-arrow-down"></i>
            </p>
          </div>
        </el-popover>
      </div>
      <div class="chart1">
        <div class="tabs-wrap">
          <e-tabs
            :active="0"
            :pane-list="paneList"
            @handleTabClick="handlePurchaseTabClick"
          ></e-tabs>
        </div>
        <div id="myChart1"></div>
        <div class="table">
          <el-table
            ref="tableData"
            size="mini"
            class="scrollbar_content"
            tooltip-effect="dark"
            :header-cell-style="{
              background: '#f5f5f5',
              color: '#333333',
              height: '40px',
              fontSize: '14px',
              fontWeight: 400,
            }"
            :data="purchaseData"
            style="width: 100%"
            border
          >
            <el-table-column
              v-for="(item, index) in purchaseColumns"
              :key="index"
              :fixed="tableFiexed(item.name)"
              min-width="90px"
              :prop="item.createDate"
              :label="item.name"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="charts_list">
        <div class="chart2">
          <div class="chart2_btn flex">
            <p
              :class="dataType == 1 ? 'active' : ''"
              @click="changeDataType(1)"
            >
              部门
            </p>
            <p
              :class="dataType == 2 ? 'active' : ''"
              @click="changeDataType(2)"
            >
              供应商
            </p>
          </div>
          <!-- <div v-show="chart2TableData.length != 0"> -->
          <div
            id="myChart2"
            :style="{ height: chart2TableData.length < 4 ? '340px' : '260px' }"
          ></div>
          <div class="chart2_table">
            <div
              v-for="(item, index) in chart2TableData"
              :key="index"
              class="chart2_table_item"
              :class="{
                item3:
                  (index + 1) % 3 != 0 && index + 1 != chart2TableData.length,
              }"
            >
              <p class="name">{{ item.name }}</p>
              <p class="count">
                {{
                  item.count > 1000
                    ? (Math.round((item.count / 10000) * 100) / 100).toFixed(
                        2
                      ) + 'w'
                    : item.count
                }}
              </p>
            </div>
          </div>
          <!-- </div> -->
          <!-- <div class="empty" v-show="chart2TableData.length == 0">
            <img src="@/assets/img/workbench/empty.png" height="160px" alt="" />
            <p class="text">暂无数据</p>
          </div> -->
        </div>
        <div class="chart3">
          <!-- <div v-show="chart3Data.length != 0"> -->
          <div id="myChart3"></div>
          <div class="chart3-table">
            <el-table
              size="mini"
              tooltip-effect="dark"
              :header-cell-style="{
                background: '#f5f5f5',
                color: '#333333',
                height: '40px',
                fontSize: '14px',
                fontWeight: 400,
              }"
              :data="chart3Data"
              style="width: 100%"
              border
            >
              <el-table-column
                prop="value1"
                label="询比价"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="value2"
                label="框架协议"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="value3"
                label="其他"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
          <!-- </div> -->
          <!-- <div class="empty" v-show="chart3Data.length == 0">
            <img src="@/assets/img/workbench/empty.png" height="160px" alt="" />
            <p class="text">暂无数据</p>
          </div> -->
        </div>
        <div class="chart4">
          <!-- <div v-show="chart4Data.length != 0"> -->
          <div id="myChart4"></div>
          <div class="chart4-table">
            <el-table
              class="scrollbar_content"
              size="mini"
              tooltip-effect="dark"
              :header-cell-style="{
                background: '#f5f5f5',
                color: '#333333',
                height: '40px',
                fontSize: '14px',
                fontWeight: 400,
              }"
              :data="chart4Data"
              style="width: 100%"
              border
            >
              <el-table-column
                v-for="(item, index) in chart4Columns"
                :key="index"
                :prop="item.lbmc"
                :label="item.lbmc"
                align="center"
              ></el-table-column>
            </el-table>
          </div>
          <!-- </div> -->
          <!-- <div class="empty" v-show="chart4Data.length == 0">
            <img src="@/assets/img/workbench/empty.png" height="160px" alt="" />
            <p class="text">暂无数据</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateformate, getYearAndMonth } from '@/modules/projectA/utils/utils';
import Api from '@/modules/projectA/api/dataCenter';
// import bus from '@/components/common/bus';
import eTabs from './e-tabs.vue';

export default {
  components: { eTabs },
  props: {
    title: {
      type: String,
      default: '',
    },
    isLayoutSet: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      minDate: null,
      maxDate: null,
      paneList: [
        {
          name: '0',
          label: '全部订单',
        },
        {
          name: '1',
          label: '易专采',
        },
        {
          name: '2',
          label: '易资源',
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            },
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 3);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          const choiceDateTime = new Date(this.selectDate).getTime();
          const minTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() - 11
          );
          const maxTime = new Date(choiceDateTime).setMonth(
            new Date(choiceDateTime).getMonth() + 11
          );
          const min = minTime;
          const newDate =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 -
            1;
          const max = newDate < maxTime ? newDate : maxTime;
          // 如果已经选中一个日期 则 返回 该日期前后12个月时间可选,后12个月最大为当前日期
          if (this.selectDate) {
            return time.getTime() < min || time.getTime() > max;
          }
          // 若一个日期也没选中 则 返回 当前日期以前日期可选
          return time.getTime() > newDate;
        },
      },
      queryData: {
        date: [
          new Date().setMonth(new Date().getMonth() - 11),
          new Date().getTime(),
        ],
      },
      purchaseData: [],
      purchaseColumns: [],
      dataType: 1,
      chart2TableData: [],
      chart3Data: [],
      chart4Columns: [],
      chart4Data: [],
      dateList: [],

      myChart1: null,
      myChart2: null,
      myChart4: null,
    };
  },
  actions: {},

  head() {
    return {};
  },
  computed: {},
  mounted() {
    this.initData();
    /* bus.$on('activeIndex', res => {
      setTimeout(() => {
        this.myChart1.resize();
        this.myChart2.resize();
      }, 500);
    }); */
    const mainChart = this.$refs.dataBoardC;
    const that = this;
    const elementResizeDetectorMaker = require('element-resize-detector');
    const erd = elementResizeDetectorMaker();
    erd.listenTo(mainChart, (ele) => {
      setTimeout(() => {
        that.myChart1 && that.myChart1.resize();
        that.myChart2 && that.myChart2.resize();
        that.myChart4 && that.myChart4.resize();
      }, 0);
    });
  },
  methods: {
    handlePurchaseTabClick(active) {
      console.log(typeof active);
      let type = '';
      if (Number(active) === 0) {
        type = 'orderBaseList';
      } else if (Number(active) === 1) {
        type = 'purchaseZoneOrderList';
      } else {
        type = 'shareOrderBaseList';
      }
      this.querySinochemOrderList(type);
    },
    tableFiexed(name) {
      // let res = false
      if (name === '年月') {
        return 'left';
      }
      if (name === '合计') {
        return 'right';
      }
      return false;
    },
    getFormatDate() {
      return `${dateformate(
        this.queryData.date[0],
        'yyyy年MM月'
      )}-${dateformate(this.queryData.date[1], 'yyyy年MM月')}`;
    },
    dateSet() {
      this.$refs.popover.doClose();
      document.getElementById('myChart2').removeAttribute('_echarts_instance_');
      this.initData();
    },
    initData() {
      // this.queryOrderByMonth();
      this.querySinochemOrderList('orderBaseList');
      this.queryOrderBySupplierAndDepartment();
      this.queryOrderLbbm();
      this.queryOrderType();
    },
    changeDataType(type) {
      // myChart2 重新渲染
      document.getElementById('myChart2').removeAttribute('_echarts_instance_');

      this.dataType = type;
      this.queryOrderBySupplierAndDepartment();
    },
    handleParams() {
      const year = dateformate(this.queryData.date[1], 'yyyy');
      const month = dateformate(this.queryData.date[1], 'M');
      const dateNum = new Date(year, month, 0).getDate();
      const list = getYearAndMonth(
        dateformate(this.queryData.date[0], 'yyyy-MM'),
        dateformate(this.queryData.date[1], 'yyyy-MM')
      );
      list.unshift(dateformate(this.queryData.date[0], 'yyyy-MM'));
      const arr = [];
      list.forEach((item) => {
        const year = item.split('-')[0];
        const month = parseInt(item.split('-')[1]);
        item = `${year}-${month}`;
        arr.push(item);
      });
      this.dateList = arr;
      return {
        startTime: dateformate(this.queryData.date[0], 'yyyy-MM-1 00:00:00'),
        endTime: dateformate(
          this.queryData.date[1],
          `yyyy-MM-${dateNum} 00:00:00`
        ),
      };
    },

    /* async queryOrderByMonth() {
      let params = this.handleParams();
      let res = await Api.queryOrderByMonth(params);
      if (res.success) {
        let resultList = res.data ? res.data : [];
        this.purchaseData = [];
        let xArr = [];
        let yArr1 = [];
        let yArr2 = [];
        let columns = [];

        let obj1 = { 年月: '采购金额' };
        let obj2 = { 年月: '订单数' };
        let count1 = 0;
        let count2 = 0;
        let allData = [];
        this.dateList.map(item => {
          let obj = {
            createDate: item,
            month: item.split('-')[1],
            orderAmount: 0,
            orderCount: 0,
            year: item.split('-')[0],
          };
          resultList.forEach(list => {
            if (item == list.createDate) {
              obj = list;
            }
          });
          allData.push(obj);
        });

        allData.map(item => {
          let name = item.year.substr(2, 4) + '年' + item.month + '月';
          xArr.push(name);
          yArr1.push(item.orderAmount);
          yArr2.push(item.orderCount);
          columns.push({
            name: name,
            ...item,
          });

          obj1[item.createDate] = item.orderAmount;
          obj2[item.createDate] = item.orderCount;
          count1 = count1 + item.orderAmount;
          count2 = count2 + item.orderCount;
        });
        this.echartsInit1(xArr, yArr1, yArr2);

        columns.unshift({
          createDate: '年月',
          name: '年月',
          orderAmount: '采购金额',
          orderCount: '订单数',
        });
        columns.push({
          createDate: '合计',
          name: '合计',
          orderAmount: '采购金额',
          orderCount: '订单数',
        });
        obj1['合计'] = count1;
        obj2['合计'] = count2;
        this.purchaseData.push(obj1);
        this.purchaseData.push(obj2);
        this.purchaseColumns = columns;
        this.purchaseData.forEach(obj => {
          for (const item in obj) {
            if (typeof obj[item] == 'number') {
              if (obj[item] > 10000) {
                obj[item] = (Math.round((obj[item] / 10000) * 100) / 100).toFixed(2) + 'w';
              } else {
                obj[item] = obj[item];
              }
            }
          }
        });

        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
      }
    }, */
    // 查询采购报表
    async querySinochemOrderList(type) {
      const params = this.handleParams();
      // const res = await Api.queryOrderByMonth(params);
      const res = await Api.queryOrderMonthForZoneShareAll(params);
      if (res.success) {
        const resultList = res.data ? res.data[type] : [];
        resultList.forEach((item) => {
          this.$set(item, 'createDate', `${item.year}-${item.month}`);
        });
        this.purchaseData = [];
        const xArr = [];
        const yArr1 = [];
        const yArr2 = [];
        const columns = [];

        const obj1 = { 年月: '采购金额' };
        const obj2 = { 年月: '订单数' };
        let count1 = 0;
        let count2 = 0;
        const allData = [];
        this.dateList.map((item) => {
          let obj = {
            createDate: item,
            month: item.split('-')[1],
            orderAmount: 0,
            orderCount: 0,
            year: item.split('-')[0],
          };
          resultList.forEach((list) => {
            if (item == list.createDate) {
              obj = list;
            }
          });
          allData.push(obj);
        });

        allData.forEach((item) => {
          const name = `${item.year.substr(2, 4)}年${item.month}月`;
          xArr.push(name);
          yArr1.push(item.orderAmount);
          yArr2.push(item.orderCount);
          columns.push({
            name,
            ...item,
          });

          obj1[item.createDate] = item.orderAmount;
          obj2[item.createDate] = item.orderCount;
          count1 += item.orderAmount;
          count2 += item.orderCount;
        });
        this.echartsInit1(xArr, yArr1, yArr2);

        columns.unshift({
          createDate: '年月',
          name: '年月',
          orderAmount: '采购金额',
          orderCount: '订单数',
        });
        columns.push({
          createDate: '合计',
          name: '合计',
          orderAmount: '采购金额',
          orderCount: '订单数',
        });
        obj1['合计'] = count1;
        obj2['合计'] = count2;
        this.purchaseData.push(obj1);
        this.purchaseData.push(obj2);
        this.purchaseColumns = columns;
        console.log(this.purchaseColumns);
        this.purchaseData.forEach((obj) => {
          for (const item in obj) {
            if (typeof obj[item] === 'number') {
              if (obj[item] > 10000) {
                obj[item] = `${(
                  Math.round((obj[item] / 10000) * 100) / 100
                ).toFixed(2)}w`;
              } else {
                obj[item] = obj[item];
              }
            }
          }
        });

        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
      }
    },
    async queryOrderBySupplierAndDepartment() {
      const params = this.handleParams();
      const res = await Api.queryOrderBySupplierAndDepartment(params);
      if (res.success) {
        const list1 = res.data.purchaseZoneDepartmentList
          ? res.data.purchaseZoneDepartmentList
          : [];
        const list2 = res.data.purchaseZoneSupplierList
          ? res.data.purchaseZoneSupplierList
          : [];
        const yData1 = [];
        const barData1 = [];
        const tableData1 = [];
        list1.forEach((item) => {
          yData1.push(item.departmentName);
          barData1.push(item.orderAmount);
          tableData1.push({
            name: item.departmentName,
            count: item.orderAmount,
          });
        });
        const yData2 = [];
        const barData2 = [];
        const tableData2 = [];
        list2.forEach((item) => {
          yData2.push(item.supplierCompanyName);
          barData2.push(item.orderAmount);
          tableData2.push({
            name: item.supplierCompanyName,
            count: item.orderAmount,
          });
        });
        if (this.dataType == 1) {
          if (list1.length > 0) {
            this.chart2TableData = [...tableData1];
            /* console.log(
              yData1,
              barData1,
              this.chart2TableData,
              'this.chart2TableData1111'
            ); */
            setTimeout(() => {
              this.echartsInit2(yData1, barData1);
            }, 10);
          } else {
            this.chart2TableData = [{ count: 0, name: '其他' }];
            this.echartsInit2(['其他'], [0]);
          }
        }
        if (this.dataType == 2) {
          if (list2.length > 0) {
            this.chart2TableData = [...tableData2];
            /* console.log(
              yData2,
              barData2,
              this.chart2TableData,
              'this.chart2TableData222'
            ); */
            setTimeout(() => {
              this.echartsInit2(yData2, barData2);
            }, 10);
          } else {
            this.chart2TableData = [{ count: 0, name: '其他' }];
            this.echartsInit2(['其他'], [0]);
          }
        }
      }
    },
    async queryOrderType() {
      const params = this.handleParams();
      const res = await Api.queryOrderType(params);
      this.chart3Data = [];
      if (res.code === '200') {
        const data = [
          {
            name: '询比价',
            value: res?.data?.enquiryAmount || 0,
          },
          {
            name: '其他',
            value: res?.data?.otherAmount || 0,
          },
          {
            name: '框架协议',
            value: res?.data?.protocolAmount || 0,
          },
        ];
        this.chart3Data.push({
          value1:
            res?.data?.enquiryAmount > 10000
              ? `${(
                  Math.round((res.data.enquiryAmount / 10000) * 100) / 100
                ).toFixed(2)}w`
              : res?.data?.enquiryAmount || 0,
          value2:
            res?.data?.protocolAmount > 10000
              ? `${(
                  Math.round((res.data.protocolAmount / 10000) * 100) / 100
                ).toFixed(2)}w`
              : res?.data?.protocolAmount || 0,
          value3:
            res?.data?.otherAmount > 10000
              ? `${(
                  Math.round((res.data.otherAmount / 10000) * 100) / 100
                ).toFixed(2)}w`
              : res?.data?.otherAmount || 0,
        });

        this.echartsInit3(data);
      }
    },

    async queryOrderLbbm() {
      const params = this.handleParams();
      const res = await Api.queryOrderLbbm(params);
      console.log(res);
      if (res.success) {
        let list = res.data ? res.data : [];
        this.chart4Data = [];
        const obj1 = {};
        if (list.length > 0) {
          list.forEach((item) => {
            item.value = item.orderAmount;
            item.name = item.lbmc;
            obj1[item.lbmc] = item.orderAmount;
          });
          this.chart4Columns = list;
          this.chart4Data.push(obj1);
          this.chart4Data.forEach((obj) => {
            for (const item in obj) {
              if (typeof obj[item] === 'number') {
                if (obj[item] > 10000) {
                  obj[item] = `${(
                    Math.round((obj[item] / 10000) * 100) / 100
                  ).toFixed(2)}w`;
                } else {
                  obj[item] = obj[item];
                }
              }
            }
          });
        } else {
          list = [{ value: 0, name: '其他' }];
          this.chart4Data = [{ 其他: 0 }];
          this.chart4Columns = [
            {
              lbmc: '其他',
              orderAmount: 0,
              value: 0,
              name: '其他',
            },
          ];
        }
        this.$nextTick(() => {
          const chartParams = JSON.parse(JSON.stringify(list));
          this.echartsInit4(chartParams);
        });
      }
    },

    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    echartsInit1(xArr, yArr1, yArr2) {
      // console.log(yArr1, '这是y轴数据');
      const yMax1 = Math.max(...yArr1);
      let yMin1 = Math.min(...yArr1);
      const yMax2 = Math.max(...yArr2);
      let yMin2 = Math.min(...yArr2);
      let interval1 = 1;
      let interval2 = 1;
      if (yArr1.length === 1) {
        interval1 = yMax1;
        interval2 = yMax2;
        yMin1 = 0;
        yMin2 = 0;
      } else {
        if (yMax1 - yMin1 > 0) {
          interval1 = (yMax1 - yMin1) / 5;
          // interval1 = interval1.toFixed(0);
        }
        if (yMax2 - yMin2 > 0) {
          interval2 = (yMax2 - yMin2) / 5;
          // interval2 = interval2.toFixed(0);
        }
      }
      this.$nextTick(() => {
        this.myChart1 = this.$echarts.init(document.getElementById('myChart1'));
        this.myChart1.setOption({
          title: {
            text: '采购趋势',
            textStyle: {
              fontSize: 14,
              color: '#333',
              fontWeight: 'normal',
            },
            padding: [20, 0, 0, 20],
          },
          legend: {
            data: ['采购金额', '订单数'],
            top: 'bottom',
          },
          tooltip: {},
          xAxis: {
            data: xArr,
          },
          // 直角坐标系内绘图网格
          grid: {
            top: '30%', // grid组件距上下左右的距离
            left: '3%',
            right: '3%',
            bottom: '10%',
            containLabel: true, // grid区域是否包含坐标轴的刻度标签。
          },

          yAxis: [
            {
              type: 'value',
              name: '采购金额',
              minInterval: 1,
              axisLabel: {
                formatter(value, index) {
                  // console.log(value, '+++++++');
                  if (value > 10000) {
                    value = `${(
                      Math.round((value / 10000) * 100) / 100
                    ).toFixed(0)}w`;
                  } else {
                    value = value.toFixed(1);
                  }
                  return value;
                },
              },
              min: yMin1,
              max: yMax1,
              splitNumber: 5,
              interval: interval1,
            },
            {
              type: 'value',
              name: '订单数',
              minInterval: 1,
              axisLabel: {
                formatter(value, index) {
                  return value.toFixed(1);
                },
              },
              min: yMin2,
              max: yMax2,
              splitNumber: 5,
              interval: interval2,
            },
          ],
          series: [
            {
              name: '采购金额',
              type: 'bar',
              data: yArr1,
              yAxisIndex: 0,
              barWidth: 18, // 柱图宽度
              /* itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#32DAFF' },
                  { offset: 1, color: '#28B2FF' },
                ]),
              }, */
              itemStyle: {
                color: '#6AA1FF',
              },
            },
            {
              name: '订单数',
              itemStyle: {
                color: '#FAAC7B',
              },
              type: 'line',
              smooth: true,
              data: yArr2,
              yAxisIndex: 1,
            },
          ],
        });
        this.resize(this.myChart1);
      });
    },
    echartsInit2(yData, barData) {
      this.myChart2 = this.$echarts.init(document.getElementById('myChart2'));
      this.myChart2.setOption({
        title: {
          text: '采购金额排行',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal',
          },
          padding: [2, 0, 0, 0],
        },
        tooltip: {},
        grid: {
          top: '15%', // grid组件距上下左右的距离
          left: '0%',
          right: '6%',
          bottom: '8%',
          containLabel: true, // grid区域是否包含坐标轴的刻度标签。
        },
        legend: {},
        xAxis: {
          axisLabel: {
            formatter(value, index) {
              if (value > 10000) {
                value = `${(Math.round((value / 10000) * 100) / 100).toFixed(
                  0
                )}w`;
              }
              return value;
            },
          },
        },
        yAxis: {
          data: yData,
          axisLabel: {
            rotate: 38,
            formatter(value, index) {
              if (value.length > 6) {
                value = `${value.substr(0, 4)}...`;
              }
              return value;
            },
          },
        },
        series: [
          {
            type: 'bar',
            data: barData,
            /* itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  { offset: 0, color: '#28B2FF' },
                  { offset: 1, color: '#32DAFF' },
                ]),
              }, */
            itemStyle: {
              color: '#6AA1FF',
            },
            barMaxWidth: 60,
          },
        ],
      });
      this.resize(this.myChart2);
    },
    echartsInit3(data) {
      this.$nextTick(() => {
        const myChart3 = this.$echarts.init(
          document.getElementById('myChart3')
        );
        myChart3.setOption({
          title: {
            text: '采购方式分布',
            textStyle: {
              fontSize: 14,
              color: '#333',
              fontWeight: 'normal',
            },
            padding: [2, 0, 0, 0],
          },

          tooltip: {},
          legend: {
            top: 'bottom',
            icon: 'circle',
            padding: [0, 0, 20, 0],
          },
          color: [
            '#6AA1FF',
            '#5EDFD6',
            'yellow',
            'green',
            'blue',
            'indigo',
            'purple',
          ],
          series: [
            {
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['20%', '50%'],
              data,
              roseType: 'radius',
              itemStyle: {
                normal: {
                  color(params) {
                    const colorList = [
                      '#6AA1FF',
                      '#5EDFD6',
                      '#C9E968',
                      '#FADC6D',
                      '#F98981',
                      '#E865DF',
                      '#625FFA',
                      '#5F81FA',
                      '#60CEF0',
                      '#4CD263',
                      '#FCF26B',
                      '#FAAC7B',
                      '#F979B7',
                      '#A871E3',
                    ];
                    if (params.name === '其他') {
                      colorList.splice(params.dataIndex, 0, '#E3E7FF');
                    }
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          ],
        });
        this.resize(myChart3);
      });
    },
    echartsInit4(data) {
      this.myChart4 = this.$echarts.init(document.getElementById('myChart4'));
      this.myChart4.setOption({
        title: {
          text: '物资分类分布',
          textStyle: {
            fontSize: 14,
            color: '#333',
            fontWeight: 'normal',
          },
          padding: [2, 0, 0, 0],
        },
        tooltip: {},
        legend: {
          top: 'bottom',
          icon: 'circle',
          padding: [0, 0, 20, 0],
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['40%', '50%'],
            data,
            itemStyle: {
              normal: {
                color(params) {
                  const colorList = [
                    '#6AA1FF',
                    '#5EDFD6',
                    '#C9E968',
                    '#FADC6D',
                    '#F98981',
                    '#E865DF',
                    '#625FFA',
                    '#5F81FA',
                    '#60CEF0',
                    '#4CD263',
                    '#FCF26B',
                    '#FAAC7B',
                    '#F979B7',
                    '#A871E3',
                  ];
                  if (params.name === '其他') {
                    colorList.splice(params.dataIndex, 0, '#E3E7FF');
                  }
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      this.resize(this.myChart4);
    },
    resize(chart) {
      window.addEventListener('resize', function () {
        chart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.data-board {
  width: 100%;
  margin-top: 20px;
  ::v-deep .el-table {
    .cell {
      overflow: visible;
      box-sizing: border-box;
      white-space: nowrap;
      word-break: normal;
      line-height: 23px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .databoard {
    .databoard_header {
      padding: 0 20px;
      height: 44px;
      background: #f5f5f5;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d9d9d9;
      .date {
        cursor: pointer;
        align-items: center;
        img {
          margin-right: 5px;
        }
        i {
          margin-left: 4px;
        }
      }
      .popover {
        ::v-deep .el-popover__reference {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 12px;
        }
      }
      .title {
        font-size: 14px;
        display: flex;
        align-items: center;
        background: #f5f5f5;
        color: #333;
        .text {
          margin-left: 10px;
        }
      }
    }
    .table {
      padding: 20px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
}
#myChart1 {
  width: 100%;
  height: 286px;
}
#myChart2 {
  width: 100%;
  height: 260px;
}
#myChart3 {
  width: 100%;
  height: 340px;
}
#myChart4 {
  width: 100%;
  height: 340px;
}
.chart1 {
  background: #ffffff;
  .tabs-wrap {
    // padding-top: 20px;
    padding: 20px 20px 0 20px;
  }
}
.charts_list {
  display: flex;
  justify-content: space-between;
  height: 462px;
  & > div:not(:last-child) {
    border-right: 1px solid #d9d9d9;
  }
  & > div {
    padding: 20px;
  }

  .chart2 {
    background: #ffffff;
    //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 33.33%;
    height: 100%;
    position: relative;
    .chart2_btn {
      position: absolute;
      right: 20px;
      top: 20px;
      background: #f5f5f5;
      border-radius: 1px;
      width: 96px;
      height: 24px;
      padding: 3px;
      z-index: 999;
      p {
        flex: 0 0 50%;
        text-align: center;
        line-height: 18px;
        color: #666666;
        font-size: 12px;
        cursor: pointer;
      }
      .active {
        color: $main-col;
        background: #fff;
      }
    }
    .chart2_table {
      display: flex;
      flex-wrap: wrap;

      max-height: 165px;
      overflow-y: auto;
      justify-content: center;
      // align-items: flex-end;
      // height: 162px;
      .chart2_table_item {
        width: 33.333333%;

        border-right: 1px solid #ebeef5;
        border-left: 1px solid #ebeef5;
        border-top: 1px solid #ebeef5;
        p {
          color: #333333;
          font-size: 14px;
          text-align: center;
          border-bottom: 1px solid #ebeef5;
        }
        .name {
          height: 40px;
          line-height: 40px;
          background: #f5f5f5;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .count {
          height: 36px;
          line-height: 36px;
        }
      }
      .item3 {
        border-right: none;
      }
    }
  }
  .chart3 {
    background: #ffffff;
    //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 33.33%;
    height: 100%;
  }
  .chart4 {
    background: #ffffff;
    //box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    width: 33.33%;
    height: 100%;
  }
}
.datepicker {
  ::v-deep .el-range-separator {
    width: 30px !important;
  }
}

/*修改滚动条样式*/
.scrollbar_content_none {
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.scrollbar_content_none::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/*修改滚动条样式*/
.scrollbar_content {
  overflow-y: auto;
  -ms-overflow-style: none;
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    height: 8px;
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 2px;
  }
  ::v-deep .el-table__fixed-right {
    height: 100% !important;
  }
  ::v-deep .el-table__fixed {
    height: 100% !important;
  }
}

.empty {
  height: 462px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .text {
    font-size: 16px;
    color: #333333;
    margin-top: 20px;
  }
}
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  background-color: #d9d9d9;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #999;
}
</style>
